import loadExistingApplication from './loadExistingApplication';
import { Dispatch } from 'redux';

const handleExistingApplication = (dispatch: Dispatch, getState: () => ReduxState) => {
  const { id: incomingApplicationId } = getState().location.payload;
  const { existingApplicationLoaded } = getState();

  if (existingApplicationLoaded === incomingApplicationId) {
    return;
  }

  return loadExistingApplication(dispatch, getState, incomingApplicationId);
};

export default handleExistingApplication;
